module.exports = __webpack_public_path__ + "static/media/arrowDownBlack.cddedbd4.svg";